import React from 'react';
import styled from 'styled-components';

import { BENEFIT_SECTION_ID } from 'pages/benefits/constants/variables';
import Outpatient from 'pages/benefits/sections/outpatients/Outpatient';
import HospitalisationSurgical from 'pages/benefits/sections/hospitalisation/HospitalisationSurgical';
import SupplementaryMajorMedical from 'pages/benefits/sections/supplementary-major-medical/SupplementaryMajorMedical';
import Dental from 'pages/benefits/sections/dental/Dental';
import Maternity from 'pages/benefits/sections/maternity/Maternity';
import WorldwideEmergencyAssistance from 'pages/benefits/sections/worldwide-emergency-assistance/WorldwideEmergencyAssistance';

const BenefitsBodyContainer = styled.div`
  margin-top: 16px;
`;

interface BenefitsBodyProp {
  selectedKey: string;
}

function BenefitsBody({ selectedKey }: BenefitsBodyProp): JSX.Element {
  const BenefitBodySection = () => {
    switch (selectedKey) {
      case BENEFIT_SECTION_ID.OUTPATIENT:
        return <Outpatient />;
      case BENEFIT_SECTION_ID.HOSPITALISATION_SURGICAL:
        return <HospitalisationSurgical />;
      case BENEFIT_SECTION_ID.SUPPLEMENTARY_MAJOR_MEDICAL:
        return <SupplementaryMajorMedical />;
      case BENEFIT_SECTION_ID.DENTAL:
        return <Dental />;
      case BENEFIT_SECTION_ID.MATERNITY:
        return <Maternity />;
      case BENEFIT_SECTION_ID.WORLDWIDE_EMERGENCY_ASSISTANCE:
        return <WorldwideEmergencyAssistance />;
      default:
        return <></>;
    }
  };
  return (
    <BenefitsBodyContainer>
      <BenefitBodySection />
    </BenefitsBodyContainer>
  );
}

export default BenefitsBody;
